import * as Sentry from '@sentry/react'
import { Capacitor } from '@capacitor/core'

/**
 * Error reporting to Bugsink (Sentry-compatible, sentry.leckerorder.com).
 * Uncaught errors and unhandled rejections are captured by the SDK itself;
 * the error boundary reports render errors via reportError. Like the device
 * diagnostics, no personal data is sent: no IPs, cookies or console output.
 */
const DSN = 'https://900cf9d0704543f9a6cf7cfc40012d77@sentry.leckerorder.com/6'

export function initErrorReporting() {
  // Dev servers and unit tests stay local.
  if (import.meta.env.DEV) return
  Sentry.init({
    dsn: DSN,
    release: `admin-v2@${__APP_VERSION__}`,
    environment: import.meta.env.MODE,
    // Bugsink keeps errors only (no sessions); console output may hold customer data.
    integrations: (defaults) => defaults.filter((i) => i.name !== 'Console' && i.name !== 'BrowserSession'),
    dataCollection: { userInfo: false, cookies: false, httpHeaders: false, httpBodies: [], urlQueryParams: false },
    initialScope: { tags: { platform: Capacitor.getPlatform() } },
  })
}

export function setErrorReportingRestaurant(restaurantId: number | null) {
  Sentry.setTag('restaurant_id', restaurantId ?? undefined)
}

export function reportError(error: unknown, componentStack?: string | null) {
  Sentry.captureException(error, componentStack ? { contexts: { react: { componentStack } } } : undefined)
}
